import _ListCache_default from "./_ListCache.js";
import _stackClear_default from "./_stackClear.js";
import _stackDelete_default from "./_stackDelete.js";
import _stackGet_default from "./_stackGet.js";
import _stackHas_default from "./_stackHas.js";
import _stackSet_default from "./_stackSet.js";

//#region ../../node_modules/lodash-es/_Stack.js
/**
* Creates a stack cache object to store key-value pairs.
*
* @private
* @constructor
* @param {Array} [entries] The key-value pairs to cache.
*/
function Stack(entries) {
	var data = this.__data__ = new _ListCache_default(entries);
	this.size = data.size;
}
Stack.prototype.clear = _stackClear_default;
Stack.prototype["delete"] = _stackDelete_default;
Stack.prototype.get = _stackGet_default;
Stack.prototype.has = _stackHas_default;
Stack.prototype.set = _stackSet_default;
var _Stack_default = Stack;

//#endregion
export { _Stack_default as default };
//# sourceMappingURL=_Stack.js.map